export default customElements.define('component-root', class ComponentRoot extends wealthify.CustomElementBaseClass {
    constructor () {
        const config = { 
            templateHTML: '<div data-root></div>',
            hasChildren: true
        };

        super(config);
    }

    // Static

    static extensions = [
        wealthify.componentExtensions.Surface
    ]

    static styleSelector = 'v2';

});